import React, { useMemo } from 'react';
import { useAppConfiguration } from '@wkda/funnel-components';
function useFormFooterContent() {
  var _useAppConfiguration = useAppConfiguration(),
    locale = _useAppConfiguration.locale;
  var localizedFooterContent = useMemo(function () {
    switch (locale) {
      case 'de-AT':
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange-at.svg',
          alt: 'wirkaufendeinauto.at',
          classes: 'mt-n1'
        };
      case 'es':
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange-es.svg',
          alt: 'compramostucoche.es',
          classes: ''
        };
      case 'fr-BE':
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange-frbe.svg',
          alt: 'vendezvotrevoiture.be',
          classes: ''
        };
      case 'fr':
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange-fr.svg',
          alt: 'vendezvotrevoiture.fr',
          classes: ''
        };
      case 'it':
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange-it.svg',
          alt: 'noicompriamoauto.it',
          classes: ''
        };
      case 'nl-BE':
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange-nlbe.svg',
          alt: 'wijkopenautos.be',
          classes: ''
        };
      case 'nl':
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange-nl.svg',
          alt: 'wijkopenautos.nl',
          classes: ''
        };
      case 'pt':
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange-pt.svg',
          alt: 'compramososeucarro.pt',
          classes: ''
        };
      case 'sv-SE':
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange-se.svg',
          alt: 'vikoperdinbil.se',
          classes: ''
        };
      default:
        return {
          src: 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-blue-orange.svg',
          alt: 'wirkaufendeinauto.de',
          classes: 'mt-n1'
        };
    }
  }, []);
  return localizedFooterContent;
}
export default function FormFooter() {
  var _useFormFooterContent = useFormFooterContent(),
    src = _useFormFooterContent.src,
    alt = _useFormFooterContent.alt,
    classes = _useFormFooterContent.classes;
  return /*#__PURE__*/React.createElement("div", {
    className: "carlead-creation-form__footer"
  }, /*#__PURE__*/React.createElement("p", {
    className: "powered-by"
  }, "Powered by "), /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("img", {
    width: "200",
    className: "img-responsive logo " + classes,
    src: src,
    alt: alt
  })));
}